import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Box,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogContent,
  DialogActions,
  Slide,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Checkbox, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Divider from "@material-ui/core/Divider";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomInput from "../../../../../Components/CustomInput";
import Icon from "@material-ui/core/Icon";
import DataService from "../../../../../Service";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleOutlinedIcon from "@material-ui/icons/RemoveCircleOutlined";
import Loader from "../../../../../Components/Loader";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Popover from "@material-ui/core/Popover";
import MaterialTable from "material-table";
import EditIcon from "@material-ui/icons/Edit";
import { IconButton } from "@material-ui/core";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useHistory } from "react-router";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InternalExternalRate from "../CoachRateCard/InternalExternalCoaching/internal_external_rate";

import PriceSummaryModal from "../Program/PriceSummaryModal";
import { Alert, AlertTitle } from "@material-ui/lab";
import Chip from "@material-ui/core/Chip";
import CustomSelectMulti from "../../../../../../src/Components/CustomSelectMulti";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../../../../src/Components/Snackbar/SnackbarActions";
import SelectSpecific from "../../../../../Components/FormGenerator/select_specific";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    display: "flex",
    color: theme.palette.text.secondary,
    "& span:last-child": {
      color: "#303030",
    },
    "& svg": {
      width: "1.5em",
      height: "1.5em",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  bottomBar: {
    boxShadow: "0px 0px 6px #232323",
    padding: "15px",
    textAlign: "center",
    margin: "0 -24px",
    marginTop: "10px",
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 1075,
    backgroundColor: "#fff",
  },
  textAreaEmpty: {
    width: "100%",
    padding: "10px",
    border: "1px solid rgb(112, 112, 112)",
    borderRadius: "4px",

    fontSize: "16px",
    fontFamily: "inherit",
  },
  // commercialBilling: {
  //     marginTop: "2rem",
  //     "& h2": {
  //         marginTop: "0",
  //         marginBottom: "38px",
  //     },
  //     "& p": {
  //         fontSize: "14px",
  //         color: "#232323",
  //     },
  // },
  summery: {
    marginTop: "39px",
    marginBottom: "39px",
    // "& h2": {
    //     marginBottom: "26px",
    // },
  },
  clientBasics: {
    marginBottom: "50px",
    // "& h2": {
    //     marginBottom: "20px",
    // },
    "& span:last-child": {
      color: "#303030",
    },
  },
  invoice: {
    // "& h2": {
    //     marginBottom: "24px",
    // },
    "& span:last-child": {
      color: "#303030",
    },
  },
  invoiceOption: {
    // "& h2": {
    //     marginBottom: "20px",
    // },
    "& span:last-child": {
      color: "#303030",
    },
  },
  invoiceDetails: {
    // "& h2": {
    //     marginBottom: "30px",
    // },
  },
  expensePolicy: {
    // "& h2": {
    //     marginBottom: "20px",
    // },
    "& span:last-child": {
      color: "#303030",
    },
  },
  tableRoot: {
    "& table": {},
    boxShadow: "none",
    "& th, & td": {
      border: "none",
      "& strong": {
        fontSize: "16px",
      },
    },
    "& th": {
      color: "#fff",
    },
    "& th:first-child": {
      borderRadius: "5px 0 0 5px",
    },
    "& th:last-child": {
      borderRadius: "0 5px 5px 0",
    },
    "& thead": {
      backgroundColor: "#00808090",
    },
    "& thead:first-child": {
      backgroundColor: "#3b86ff26",
      borderRadius: "5px",
      "& th": {
        color: "#3B86FF",
      },
    },
  },
  marginTableRoot: {
    backgroundColor: "#F8F8F8",
    borderRadius: "0",
    boxShadow: "none",
    "& th, & td": {
      border: "none",
    },
  },
  buttonCss: {
    textTransform: "capitalize",
    width: "128px",
    height: "40px",
    fontWeight: 900,
  },
  typography: {
    padding: theme.spacing(2),
  },
  popOverRoot: {
    padding: "2rem 3rem",
  },
  menuPaper: {
    height: "40rem",
    // marginTop:"3rem"
    top: "183px !important",
  },
  chipComponent: {
    "& div": {
      "& div > div": {
        borderRadius: "3px",
        "& svg": {
          color: "var(--unnamed-color-ffffff)",
        },
      },
    },
  },
  fieldSelection: {
    display: "flex",
    "& p": {
      marginRight: "20px",
    },
    "& > div": {
      width: "60%",
    },
  },
  labelContainer: {
    flexDirection: "column",
    "& .MuiStepLabel-labelContainer": {
      marginTop: "10px",
    },
  },
  stepperContainer: {
    alignItems: "flex-start",
    "& .MuiStepConnector-root": {
      marginTop: "10px",
    },
    "& .MuiStepIcon-root": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
    "& .MuiStepIcon-text": {
      fill: "white !important",
    },
    "& .MuiStepLabel-label": {
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiStepLabel-active": {
      color: "black !important",
    },
    "& .MuiStepIcon-active": {
      color: "#077F83 !important",
    },
    "& .MuiStepIcon-completed": {
      color: "#077F83 !important",
      backgroundColor: "transparent",
    },
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const rateCardType = ["Programme Price", "Session Rate", "Hourly Rate"];

const clientInvoicingBasics = {
  PO: [
    {
      name: "po_number_for_each_assignment",
      value: "PO Number for each assignment",
    },
    {
      name: "no_po_number",
      value: "No PO Number",
    },
    {
      name: "po_number_for_multiple_assignment",
      value: "PO Number for multiple assignment",
    },
    {
      name: "combination",
      value: "Multiple PO for multiple assignments",
    },
  ],
  BILLING: [
    {
      name: "centralised_billing",
      value:
        "Centralised billing (Covers both single and multiple assignments)",
    },
    {
      name: "distributed_billing",
      value: "Distributed billing",
    },
  ],
  SUPPLIERS: [
    {
      name: "independent_coach_delivery",
      value: "Independent coach delivery",
    },
    {
      name: "multiple_coach_suppliers",
      value: "Multiple coach suppliers",
    },
  ],
  ASSIGNMENTS: [
    {
      name: "single_assignment_adhoc",
      value: "Single assignment Ad hoc",
    },
    {
      name: "multiple_assignments_block",
      value: "Multiple assignments block/starting at the same time",
    },
  ],
};

const clientInvoicingScheduleArray = [
  { id: 1, name: "tranche", value: "Tranche" },
  { id: 2, name: "each_session", value: "Each session" },
  { id: 3, name: "monthly", value: "Monthly" },
];

const addOnsInvoicingScheduleArray = [
  { id: 1, name: "tranche", value: "Tranche" },
  { id: 2, name: "each_session", value: "Each session" },
  { id: 3, name: "monthly", value: "Monthly" },
];

const programPriceType = [
  "Of program price",
  "Of program price after completion in hours",
  "Of program price after completion in sessions",
];

const addOnsPriceType = [
  "Of add-on price",
  "Of add-on price after completion in hours",
  "Of add-on price after completion in sessions",
];

const installmentType = ["In advance", "At midpoint", "On completion"];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CoachingCommercialClient = (props) => {
  console.log("props", props);
  const {
    currentSelection,
    tabIndex,
    organisationId,
    setTabIndex,
    fetchApiFlag,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [commercialBillingData, setCommercialBillingData] = useState({});
  const [moduleSetups, setModuleSetups] = useState([]);
  const [checkBoxValue, setCheckBoxValue] = useState({});
  const [clientBillingScheduleArray, setClientBillingScheduleArray] = useState([
    {},
  ]);
  const [addOnBillingScheduleArray, setAddOnBillingScheduleArray] = useState([
    {},
  ]);
  const [selectDropDownValue, setSelectDropDownValue] = useState({});
  const [inputValue, setInputValue] = useState({});
  const [levelData, setLevelData] = useState([]);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState({});
  const [emailData, setEmailData] = useState([]);
  const [clientInvoicingSelectedId, setClientInvoicingSelectedId] =
    useState(undefined);
  const [addOnsInvoicingSelectedId, setAddOnsInvoicingSelectedId] =
    useState(undefined);
  const [clientInvoicingCheck, setClientInvoicingCheck] = useState(null);
  const [addOnsInvoicingCheck, setAddOnsInvoicingCheck] = useState(null);
  const [moduleSetupLoading, setModuleSetupLoading] = useState(false);

  const [viewCardPopover, setViewCardPopover] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [rateCardInfo, setRateCardInfo] = useState([]);
  const [countryData, setCountryData] = useState(undefined);

  const [totalCount, setTotalCount] = useState(100);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [currentRateCardSelection, setCurrentRateCardSelection] = useState({});
  const [priceSummaryData, setPriceSummaryData] = useState({});
  const [addonData, setAddonData] = useState([]);
  const [action, setAction] = useState(null);
  const [moduleSetupData, setModuleSetup] = useState([]);
  const [moduleSetupData1, setModuleSetup1] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [priceSummaryModal, setPriceSummaryModal] = useState(false);
  const [priceSummaryFlag, setPriceSummaryFlag] = useState({});
  const [priceSummaryInputValue, setPriceSummaryInputValue] = useState({});
  const [elementPrice, setElementPrice] = useState(0);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [coachingPrice, setCoachingPrice] = useState();
  const [stepperValue, setStepperValue] = useState(0);
  const history = useHistory();

  const clientBillingPercentTotal = clientBillingScheduleArray?.reduce(
    (totalPer, data) => totalPer + parseInt(data.percentage, 10),
    0
  );
  const addOnsPercentTotal = addOnBillingScheduleArray?.reduce(
    (totalPerData, data) => totalPerData + parseInt(data.percentage, 10),
    0
  );

  const [expencePolicyArray, setExpencePolicyArray] = useState([
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "travel",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "travel_time",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "third_party",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "psychometric",
    },
    {
      expense_available: false,
      expense_description: "",
      expense_frequency: "",
      other_frequency_value: "",
      policy_type: "material",
    },
  ]);

  const frequencyMilestoneArray = [
    "After X session and end of assignment",
    "At the end of assignment",
    "Monthly",
    "After each session",
    "After 60% and after 40%",
    "Other",
  ];

  useEffect(() => {
    if (selectDropDownValue?.rate_card_type) {
      props?.setRateCardType(selectDropDownValue?.rate_card_type);
      props?.setLevel(selectDropDownValue?.level);
    } else {
      props?.setLevel("");
      props?.setRateCardType("");
    }
  }, [selectDropDownValue?.rate_card_type]);

  useEffect(() => {
    if (selectDropDownValue?.level) {
      props?.setLevel(selectDropDownValue?.level);
    } else {
      props?.setLevel("");
    }
  }, [selectDropDownValue?.level]);

  const handleCountryChange = (value) => {
    setCountryData(value);
    props?.setCountry(value);
  };

  const ExternalCoaching = () => {
    setModuleSetup(currentRateCardSelection);
  };
  const InternalCoaching = () => {
    setModuleSetup1({});
  };

  useEffect(() => {
    ExternalCoaching();
    InternalCoaching();
  }, [currentRateCardSelection]);

  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(moduleSetupData);
      setModuleSetup(moduleList);
    } else if (data && data.id) {
      moduleList = moduleSetupData.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModuleSetup(moduleList);
    } else if (!data && id) {
      moduleList = moduleSetupData.filter((base) => base.id !== id);
      setModuleSetup(moduleList);
    }
    setAction(null);
    setCurrentRateCardSelection({});
  };
  const handleClose1 = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(moduleSetupData1);
      setModuleSetup1(moduleList);
    } else if (data && data.id) {
      moduleList = moduleSetupData1.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModuleSetup1(moduleList);
    } else if (!data && id) {
      moduleList = moduleSetupData1.filter((base) => base.id !== id);
      setModuleSetup1(moduleList);
    }
    // setAction(null);
    setCurrentRateCardSelection({});
  };

  useEffect(() => {
    moduleSetup();
    fetchLevels();
  }, []);

  useEffect(() => {
    fetchCommercialBilling();
  }, [fetchApiFlag]);

  useEffect(() => {
    if (
      currentSelection?.id &&
      countryData &&
      selectDropDownValue?.rate_card_type
    ) {
      fetchPriceSummary();
    }
  }, [
    currentSelection,
    countryData,
    selectDropDownValue,
    currentRateCardSelection,
  ]);

  useEffect(() => {
    if (Boolean(viewCardPopover)) {
      fetchCountry();
    }
  }, [viewCardPopover]);

  useEffect(() => {
    fetchRateCardInfo();
  }, [countryData, pageSize, page]);

  const moduleSetup = () => {
    setTimeout(() => {
      setModuleSetupLoading(true);
      DataService.getDirectData(`/module_setups/listing_modules`)
        .then((res) => {
          if (res?.["success"]) {
            setModuleSetups(res["modules"]);
            setModuleSetupLoading(false);
          }
        })
        .catch((error) => {
          setModuleSetupLoading(false);
        });
    }, 1000);
  };

  const fetchLevels = () => {
    DataService.getData({ organisation_id: organisationId }, `fetch_level`)
      .then((res) => {
        if (res?.success) {
          setLevelData(res?.levels);
        }
      })
      .catch((error) => {});
  };

  const fetchCommercialBilling = () => {
    setLoading(true);
    const params = {
      user_type: "client",
    };
    props?.action == "editMaster"
      ? (params["master_template_id"] = currentSelection?.id)
      : (params["programme_id"] = currentSelection?.id);
    const apiUrl =
      props?.action == "editMaster"
        ? "fetch_commercial_billing"
        : "commercial_billing";
    DataService.getData(params, apiUrl)
      .then((res) => {
        console.log("res", res);
        if (res?.success) {
          props?.setStepperData(
            res?.header_name || "Coaching commercials & billing"
          );
          props?.setHeaderType("commercials_and_billing");
          props?.setFetchApiFlag(false);
          setLoading(false);
          setCommercialBillingData(res?.data);
          props?.setProgramForCoach(res?.data?.margin_percent?.for_coach);
          props?.setElementForCoach(
            res?.data?.margin_percent?.for_coach_add_ons
          );
          setInputValue({
            name: res?.data?.invoicing_detail?.name || "",
            invoice_address: res?.data?.invoicing_detail?.invoice_address || "",
            invoice_narrative:
              res?.data?.invoicing_detail?.invoice_narrative || "",
            travel_expenses_description:
              res?.data?.expense_policy?.travel_expenses_description || "",
            travel_time_description:
              res?.data?.expense_policy?.travel_time_description || "",
            third_parties_description:
              res?.data?.expense_policy?.third_parties_description || "",
            psychometrics_description:
              res?.data?.expense_policy?.psychometrics_description || "",
            materials_description:
              res?.data?.expense_policy?.materials_description || "",
            num_of_sessions: res?.data?.num_of_sessions || "",
            num_of_hours: res?.data?.num_of_hours || "",
            for_acuity: res?.data?.margin_percent?.for_acuity || "",
            for_acuity_add_ons:
              res?.data?.margin_percent?.for_acuity_add_ons || "",
            for_coach: res?.data?.margin_percent?.for_coach || "",
            for_coach_add_ons:
              res?.data?.margin_percent?.for_coach_add_ons || "",
            client_num_of_session:
              res?.data?.primary_invoicing_schedule?.num_of_session || "",
            client_num_of_month:
              res?.data?.primary_invoicing_schedule?.num_of_month || "",
            addons_num_of_session:
              res?.data?.add_ons_invoicing_schedule?.num_of_session || "",
            addons_num_of_month:
              res?.data?.add_ons_invoicing_schedule?.num_of_month || "",
          });
          setEmailData(
            res?.data?.invoicing_detail?.email?.length
              ? res?.data?.invoicing_detail?.email
              : []
          );
          setTextAreaValue({
            payment_terms: res?.data?.invoicing_basic?.payment_terms || "",
          });
          setSelectDropDownValue({
            rate_card_type: res?.data?.rate_card_type || "",
            add_ons: res?.data?.add_ons || "",
            level: res?.data?.level || "",
            rate_card_id: "",
            travel_expenses_frequency:
              res?.data?.expense_policy?.travel_expenses_frequency || "",
            travel_time_frequency:
              res?.data?.expense_policy?.travel_time_frequency || "",
            third_parties_frequency:
              res?.data?.expense_policy?.third_parties_frequency || "",
            psychometrics_frequency:
              res?.data?.expense_policy?.psychometrics_frequency || "",
            materials_frequency:
              res?.data?.expense_policy?.materials_frequency || "",
            num_of_tranche:
              res?.data?.primary_invoicing_schedule?.num_of_tranche || "",
            add_on_num_of_tranche:
              res?.data?.add_ons_invoicing_schedule?.num_of_tranche || "",
          });
          setCheckBoxValue({
            client_invoice: Boolean(
              res?.data?.invoicing_option?.client_invoice
            ),
            drawdone_from_single_payment: Boolean(
              res?.data?.invoicing_option?.drawdone_from_single_payment
            ),
            raise_proforma: Boolean(
              res?.data?.invoicing_option?.raise_proforma
            ),
            coach_can_claim_expenses_from_acuity: Boolean(
              res?.data?.expense_policy?.coach_can_claim_expenses_from_acuity
            ),
            expenses_reclaimable_from_client: Boolean(
              res?.data?.expense_policy?.expenses_reclaimable_from_client
            ),

            materials: Boolean(res?.data?.expense_policy?.materials),
            psychometrics: Boolean(res?.data?.expense_policy?.psychometrics),
            third_parties: Boolean(res?.data?.expense_policy?.third_parties),
            travel_expenses: Boolean(
              res?.data?.expense_policy?.travel_expenses
            ),
            travel_time: Boolean(res?.data?.expense_policy?.travel_time),

            po_number_for_each_assignment: Boolean(
              res?.data?.invoicing_basic?.po_number_for_each_assignment
            ),
            single_assignment_adhoc: Boolean(
              res?.data?.invoicing_basic?.single_assignment_adhoc
            ),
            po_number_for_multiple_assignment: Boolean(
              res?.data?.invoicing_basic?.po_number_for_multiple_assignment
            ),
            multiple_assignments_block: Boolean(
              res?.data?.invoicing_basic?.multiple_assignments_block
            ),
            no_po_number: Boolean(res?.data?.invoicing_basic?.no_po_number),
            centralised_billing: Boolean(
              res?.data?.invoicing_basic?.centralised_billing
            ),
            independent_coach_delivery: Boolean(
              res?.data?.invoicing_basic?.independent_coach_delivery
            ),
            distributed_billing: Boolean(
              res?.data?.invoicing_basic?.distributed_billing
            ),
            combination: Boolean(res?.data?.invoicing_basic?.combination),
            multiple_coach_suppliers: Boolean(
              res?.data?.invoicing_basic?.multiple_coach_suppliers
            ),
            coaching_request_form: Boolean(
              res?.data?.invoicing_basic?.coaching_request_form
            ),
            coaching_review_form: Boolean(
              res?.data?.invoicing_basic?.coaching_review_form
            ),
          });
          setClientInvoicingCheck(
            res?.data?.primary_invoicing_schedule?.invoicing_type
          );
          setAddOnsInvoicingCheck(
            res?.data?.add_ons_invoicing_schedule?.invoicing_type
          );
          setClientBillingScheduleArray(
            res?.data?.primary_invoicing_schedule?.billing_schedules || [{}]
          );
          setAddOnBillingScheduleArray(
            res?.data?.add_ons_invoicing_schedule?.billing_schedules || [{}]
          );

          setExpencePolicyArray(
            res?.data?.expense_policy?.expense_policy_details.length > 0
              ? res?.data?.expense_policy?.expense_policy_details
              : expencePolicyArray
          );
          setAddonData(
            res?.data?.price_summary
              .filter((item) => item.category !== "primary")
              ?.map((item) => ({ ...item, tempPrice: item.total_price,price:item.total_price,total_price:item.total_price })).filter((el)=>el.label!==null)
          );
          res?.data?.price_summary.forEach((item) => {
            if (item.category === "primary") {
              setInputValue({
                ...inputValue,
                for_acuity: item.acuity_margin_percent,
                for_coach: item.coach_margin_percent,
                num_of_hours: item.num_of_hours,
                num_of_sessions: item.num_of_hours,
              });
              setPriceSummaryData({
                ...priceSummaryData,
                label: item.label,
                price:item.total_price|| parseInt(res.data.total_pgm_price)-parseInt(res.data.specified_element_price),
                rate_card_type: res?.data?.rate_card_type,
                hourly_rate: item.rate_card_type_price,
                session_rate: item.rate_card_type_price,
                num_of_hours: item.num_of_hours,
                currency: item.currency || "",
              });
            }
          });
          setStepperValue(res?.data?.level ? 2 : 0);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const clientInvoicingHandle = (id, event) => {
    const { name } = event?.target;
    setClientInvoicingSelectedId(id);
    setClientInvoicingCheck(name === clientInvoicingCheck ? undefined : name);
  };
  const addOnsInvoicingHandle = (id, event) => {
    const { name } = event?.target;
    setAddOnsInvoicingSelectedId(id);
    setAddOnsInvoicingCheck(name === addOnsInvoicingCheck ? undefined : name);
  };

  const addonOption = moduleSetups?.map((value) => {
    return {
      id: value.id,
      label: value.module_name,
      value: value.module_name,
    };
  });

  let moduleFilteredData =
    moduleSetups &&
    moduleSetups.filter((e) => {
      return e.module_name === selectDropDownValue.add_ons;
    });

  const onChangeMultiItem = (selectedAddOns) => {
    if (selectedAddOns?.length && selectedAddOns.length > addonData.length) {
      if (selectedAddOns?.length > 1) {
        const newValue = selectedAddOns[selectedAddOns.length - 1];
        delete newValue?.id;
        selectedAddOns.splice(selectedAddOns.length - 1, 1, {
          ...newValue,
          price: 0,
        });
      } else {
        delete selectedAddOns[0]?.id;
      }
    }
    setAddonData(selectedAddOns);
  };

  const addClientBillingSchedules = () => {
    const values = [...clientBillingScheduleArray];
    values.push({});
    setClientBillingScheduleArray(values);
  };

  const removeClientBillingSchedules = (index) => {
    const values = [...clientBillingScheduleArray];
    values.splice(index, 1);
    setClientBillingScheduleArray(values);
  };

  const addAddOnBillingSchedules = () => {
    const values = [...addOnBillingScheduleArray];
    values.push({});
    setAddOnBillingScheduleArray(values);
  };

  const removeAddOnBillingSchedules = (index) => {
    const values = [...addOnBillingScheduleArray];
    values.splice(index, 1);
    setAddOnBillingScheduleArray(values);
  };

  const handleAddOnBillingSchedules = (data, id, index) => {
    if (id) {
      // set input value
      const values = [...addOnBillingScheduleArray];
      values[index][id] = data;
      setAddOnBillingScheduleArray(values);
    } else {
      // set dropdown value
      const values = [...addOnBillingScheduleArray];
      values[index][data.id] = data.value;
      setAddOnBillingScheduleArray(values);
    }
  };

  const handleClientBillingSchedules = (data, id, index) => {
    if (id) {
      // set input value
      const values = [...clientBillingScheduleArray];
      values[index][id] = data;
      setClientBillingScheduleArray(values);
    } else {
      // set dropdown value
      const values = [...clientBillingScheduleArray];
      values[index][data.id] = data.value;
      setClientBillingScheduleArray(values);
    }
  };

  const handleSelectedValue = (event, index) => {
    setSelectDropDownValue({ ...selectDropDownValue, [event.id]: event.value });
    setStepperValue(event.id === "level" ? 1 : 2);
  };

  useEffect(() => {
    if (priceSummaryData?.price) setCoachingPrice(priceSummaryData.price);
  }, [priceSummaryData?.price]);

  const handlePriceSummaryInputChange = (
    inputStateValue,
    inputName,
    inputId,
    type
  ) => {
    if (type === "addOn") {
      setAddonData((prevValues) =>
        prevValues.map((value, index) => {
          if (index === inputId) {
            value[inputName] = inputStateValue;
            return { ...value };
          }
          return value;
        })
      );
    } else if (type === "primary") {
      setCoachingPrice(parseInt(inputStateValue));
    } else {
      setInputValue({ ...inputValue, [inputName]: inputStateValue });
    }
  };

  const handleInputChange = (inputStateValue, inputName) => {
    setInputValue({ ...inputValue, [inputName]: inputStateValue });
  };

  const handleCheckboxValue = (event) => {
    if (event.target.name === "invoicing_type") {
      setCheckBoxValue({
        ...checkBoxValue,
        [event.target.name]: event.target.value,
      });
    } else {
      setCheckBoxValue({
        ...checkBoxValue,
        [event.target.name]: event.target.checked,
      });
    }
  };

  const handleChangeTextArea = (event) => {
    const { name, value } = event?.target;
    setTextAreaValue({ ...textAreaValue, [name]: value });
  };

  const handleExpencePolicyDetail = (data, name, index) => {
    const values = [...expencePolicyArray];
    values[index][name] = data;
    setExpencePolicyArray(values);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clientBillingPercentTotal && clientBillingPercentTotal != 100) {
      return;
    }
    let clientBillingSchedules =
      clientBillingScheduleArray &&
      clientBillingScheduleArray.map((data, index) => {
        return {
          billing_schedule_id: data?.billing_schedule_id
            ? data.billing_schedule_id
            : "",
          percentage: data?.percentage
            ? `${data.percentage.replace("%", "")}%`
            : "",
          pgm_price_type: data?.pgm_price_type ? data.pgm_price_type : "",
          completion_time: data?.completion_time || "",
          installment_type: data?.installment_type ? data.installment_type : "",
        };
      });
    let addOnBillingSchedules =
      addOnBillingScheduleArray &&
      addOnBillingScheduleArray.map((data, index) => {
        return {
          billing_schedule_id: data?.billing_schedule_id
            ? data.billing_schedule_id
            : "",
          percentage: data?.percentage
            ? `${data.percentage.replace("%", "")}%`
            : "",
          pgm_price_type: data.pgm_price_type ? data.pgm_price_type : "",
          completion_time: data?.completion_time || "",
          installment_type: data?.installment_type ? data.installment_type : "",
        };
      });

    const numOfHours = () => {
      if (selectDropDownValue?.rate_card_type === "Hourly Rate") {
        return inputValue?.num_of_hours;
      } else if (selectDropDownValue?.rate_card_type === "Session Rate") {
        return inputValue?.num_of_sessions;
      } else {
        return "";
      }
    };

    const rate = () => {
      if (selectDropDownValue?.rate_card_type === "Hourly Rate") {
        return priceSummaryData?.hourly_rate;
      } else if (selectDropDownValue?.rate_card_type === "Session Rate") {
        return priceSummaryData?.session_rate;
      } else {
        return "";
      }
    };
    const priceSummaryPrimaryData = commercialBillingData?.price_summary?.find(
      (item) => item.category === "primary"
    );
    const priceSummaryPrimaryObj = {
      category: "primary",
      level: selectDropDownValue.level ? selectDropDownValue.level : "",
      label: priceSummaryData?.label || selectDropDownValue?.label,
      price: priceSummaryData?.price || selectDropDownValue?.price,
      num_of_hours: numOfHours(),
      rate_card_type_price: rate(),
      acuity_margin_percent: inputValue?.for_acuity,
      coach_margin_percent: inputValue?.for_coach,
    };

    const priceSummaryDataArray = [
      priceSummaryPrimaryData?.id
        ? { ...priceSummaryPrimaryObj, id: priceSummaryPrimaryData.id }
        : priceSummaryPrimaryObj,
      ...addonData.filter(el=>el.label!==null).map((item) =>
        item?.id
          ? {
              id: item.id,
              category: "add_ons",
              label: item.value,
              price:  parseInt(item.total_price)||parseInt(item.price),
              acuity_margin_percent: item.acuity_margin_percent,
              coach_margin_percent: item.coach_margin_percent,
            }
          : {
              category: "add_ons",
              label: item.value,
              price:  parseInt(item.total_price)||parseInt(item.price),
              acuity_margin_percent: item.acuity_margin_percent,
              coach_margin_percent: item.coach_margin_percent,
            }
      ),
    ];
    let obj = {
      programme_id: (currentSelection?.id).toString(),
      user_type: tabIndex === 0 && "client",
      level: selectDropDownValue.level ? selectDropDownValue.level : "",
      rate_card_type: selectDropDownValue?.rate_card_type,
      add_ons: addonData.map((item) => item.label),
      total_coaching_pgm_price: priceSummaryData?.price || "",
      specified_element_price: elementPrice,
      total_pgm_price: priceSummaryData?.price + elementPrice || "",
      price_summary: priceSummaryDataArray,
      margin_percent: {
        for_acuity: inputValue?.for_acuity,
        for_coach: inputValue?.for_coach,
        for_acuity_add_ons: inputValue?.for_acuity_add_ons,
        for_coach_add_ons: inputValue?.for_coach_add_ons,
      },
      invoicing_basic: {
        po_number_for_each_assignment: Boolean(
          checkBoxValue?.po_number_for_each_assignment
        ),
        po_number_for_multiple_assignment: Boolean(
          checkBoxValue?.po_number_for_multiple_assignment
        ),
        no_po_number: Boolean(checkBoxValue?.no_po_number),
        independent_coach_delivery: Boolean(
          checkBoxValue?.independent_coach_delivery
        ),
        combination: Boolean(checkBoxValue?.combination),
        single_assignment_adhoc: Boolean(
          checkBoxValue?.single_assignment_adhoc
        ),
        multiple_assignments_block: Boolean(
          checkBoxValue?.multiple_assignments_block
        ),
        centralised_billing: Boolean(checkBoxValue?.centralised_billing),
        distributed_billing: Boolean(checkBoxValue?.distributed_billing),
        multiple_coach_suppliers: Boolean(
          checkBoxValue?.multiple_coach_suppliers
        ),
        payment_terms: textAreaValue?.payment_terms,
      },
      primary_invoicing_schedule: {
        invoicing_type: clientInvoicingCheck || "",
        num_of_tranche: selectDropDownValue?.num_of_tranche,
        billing_schedules: clientBillingSchedules,
        num_of_session: inputValue?.client_num_of_session,
        num_of_month: inputValue?.client_num_of_month,
      },
      add_ons_invoicing_schedule: {
        invoicing_type: addOnsInvoicingCheck || "",
        num_of_tranche: selectDropDownValue?.add_on_num_of_tranche,
        billing_schedules: addOnBillingSchedules,
        num_of_session: inputValue?.addons_num_of_session,
        num_of_month: inputValue?.addons_num_of_month,
      },
      invoicing_option: {
        client_invoice: Boolean(checkBoxValue?.client_invoice),
        raise_proforma: Boolean(checkBoxValue?.raise_proforma),
        drawdone_from_single_payment: Boolean(
          checkBoxValue?.drawdone_from_single_payment
        ),
      },
      invoicing_detail: {
        name: inputValue?.name ? inputValue.name : "",
        invoice_address: inputValue?.invoice_address
          ? inputValue.invoice_address
          : "",
        email: emailData || [],
        invoice_narrative: inputValue?.invoice_narrative
          ? inputValue.invoice_narrative
          : "",
      },
      expense_policy: {
        expenses_reclaimable_from_client: Boolean(
          checkBoxValue?.expenses_reclaimable_from_client
        ),
        coach_can_claim_expenses_from_acuity: Boolean(
          checkBoxValue?.coach_can_claim_expenses_from_acuity
        ),
        expense_policy_details:
          expencePolicyArray.length > 0 ? expencePolicyArray : null,
      },
      country: props?.country,
    };
    props?.action == "editMaster"
      ? (obj["master_template_id"] = (currentSelection?.id).toString())
      : (obj["programme_id"] = (currentSelection?.id).toString());
    if ((obj && addOnsPercentTotal > 100) || clientBillingPercentTotal > 100) {
      return null;
    } else {
      if (
        inputValue?.for_acuity &&
        inputValue?.for_coach &&
        priceSummaryData?.price &&
        clientInvoicingCheck
      ) {
        if (!addonData?.length || (addonData?.length && addOnsInvoicingCheck)) {
          if (!commercialBillingData?.id) {
            setNextButtonLoading(true);
            const createApiUrl =
              props?.action == "editMaster"
                ? "create_commercial_billing"
                : "commercial_billing";
            DataService.createData(obj, createApiUrl).then((res) => {
              DataService.createData(obj, "create_commercial_billing")
                .then((res) => {
                  if (res?.success) {
                    setNextButtonLoading(false);
                    fetchCommercialBilling();
                    action === "edit" ? setAction(null) : setTabIndex(1);
                    fetchRateCardInfo();
                    window.document.getElementsByClassName(
                      "MuiDrawer-paperAnchorRight"
                    )[0].scrollTop = 0;
                  }
                })
                .catch((error) => {
                  setNextButtonLoading(false);
                });
            });
          } else {
            setNextButtonLoading(true);
            const updateApiUrl =
              props?.action == "editMaster"
                ? "update_commercial_billing"
                : "commercial_billing";
            DataService.updateData(obj, "", updateApiUrl)
              .then((res) => {
                if (res?.success) {
                  setNextButtonLoading(false);
                  fetchCommercialBilling();
                  action === "edit" ? setAction(null) : setTabIndex(1);
                  fetchRateCardInfo();
                  window.document.getElementsByClassName(
                    "MuiDrawer-paperAnchorRight"
                  )[0].scrollTop = 0;
                }
              })
              .catch((error) => {
                setNextButtonLoading(false);
              });
          }
        } else {
          if (action !== "edit") {
            window.document.getElementsByClassName(
              "MuiDrawer-paperAnchorRight"
            )[0].scrollTop = 0;
            setSubmitClickFlag(true);
            dispatch(
              showSnackbar("error", [
                "Please Select atleast one from add-on invoicing schedule!",
              ])
            );
          } else {
            setAction(null);
            fetchRateCardInfo();
          }
        }
      } else {
        if (action !== "edit") {
          window.document.getElementsByClassName(
            "MuiDrawer-paperAnchorRight"
          )[0].scrollTop = 0;
          setSubmitClickFlag(true);
          if (!clientInvoicingCheck) {
            dispatch(
              showSnackbar("error", [
                "Please Select atleast one from Client invoicing schedule!",
              ])
            );
          }
        } else {
          fetchRateCardInfo();
          setAction(null);
        }
      }
    }
  };

  const fetchCountry = () => {
    DataService.getData("", `listing_countries_dropdown`)
      .then((res) => {
        if (res?.success) {
          setCountryList(res?.country_lists);
        }
      })
      .catch((error) => {});
  };
  {
    console.log("currentData", currentSelection);
  }
  const fetchRateCardInfo = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 5,
      programme_id: currentSelection?.id,
      country: countryData ? countryData : "",
    };
    if (Object.values(params)?.length === 4) {
      DataService.getData(params, `rate_card_info`)
        .then((res) => {
          if (res?.success) {
            setTotalCount(res?.total_count);
            setRateCardInfo(res?.rate_cards);
          } else {
            setTotalCount(100);
          }
        })
        .catch((error) => {});
    }
  };

  const fetchPriceSummary = () => {
    // debugger
    const params = {
      programme_id: currentSelection?.id,
      country: countryData,
      rate_card_type: selectDropDownValue?.rate_card_type,
      level: selectDropDownValue?.level,
      rate_card_id: selectDropDownValue?.rate_card_id,
    };
    if (Object.values(params)?.length === 5) {
      DataService.getData(params, `program_client_price_summary`)
        .then((res) => {
          if (res?.success) {
            if (res?.error_message) {
              setViewCardPopover(false);
              dispatch(showSnackbar("error", [res?.error_message]));
              setSubmitClickFlag(true);
            } else {
              props?.setProgramPriceSummary("9900");
              setPriceSummaryData({
                ...priceSummaryData,
                label: res?.label,
                price: parseInt(res?.price) ||parseInt(res.price.match(/\d+/g)),
                hourly_rate: res?.hourly_rate,
                rate_card_type: res?.rate_card_type,
                session_rate: res?.session_rate,
                currency: res?.currency||res.price.match(/[a-zA-Z]+/g) || "",
              });
            }
          }
        })
        .catch((error) => {});
    }
  };

  const handlePriceSummaryModal = (boolValue, text, id) => {
    setInputValue({ ...inputValue });
    setPriceSummaryModal(boolValue);
    setPriceSummaryFlag({ text, id });
  };

  const handleModalSubmit = (priceSummaryIndex) => {
    if (priceSummaryFlag.text === "totalProgramPrice") {
      setAddonData((prevValues) =>
        prevValues.map((value, index) => {
          if (index === priceSummaryIndex) {
            return { ...value, price: value.tempPrice };
          }
          return value;
        })
      );
      handlePriceSummaryModal(false, "");
    } else {
      setPriceSummaryData((prevValues) => ({
        ...prevValues,
        price: coachingPrice,
      }));
      handlePriceSummaryModal(false, "");
    }
  };

  useEffect(() => {
    const reducer = (previousValue, currentValue) =>
      previousValue + currentValue;
    setElementPrice(
      addonData
        ?.map((item) => (item.price ? parseInt(item.price) : 0))
        .reduce(reducer, 0)
    );
  }, [addonData]);

  return (
    <>
      <form spellCheck="false" onSubmit={handleSubmit}>
        <Container style={{ marginLeft: "-45px" }} maxWidth="xl">
          {loading && <Loader />}
          <Grid xs={12} container className={classes.commercialBilling}>
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#f7f7f7",
                padding: "10px",
                marginBottom: "10px",
              }}
            >
              <Stepper
                activeStep={stepperValue}
                style={{
                  backgroundColor: "transparent",
                  padding: "24px 93px 24px 24px",
                }}
                className={classes.stepperContainer}
              >
                {["Step 1", "Step 2", "Step 3"].map((label) => (
                  <Step
                    key={label}
                    style={{
                      border: "none",
                      padding: "0px",
                      margin: "0px",
                      width: "50px",
                      backgroundColor: "transparent",
                    }}
                  >
                    <StepLabel className={classes.labelContainer}>
                      <Typography variant="h2">{label}</Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Grid
                container
                style={{ justifyContent: "space-evenly", paddingLeft: "32px" }}
              >
                <Grid item xs={2} lg={5} md={6}>
                  <div className={classes.fieldSelection}>
                    <Typography
                      variant="h2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "8px",
                      }}
                    >
                      Level
                    </Typography>
                    <CustomSelect
                      id="level"
                      name={"level"}
                      targetId={"level"}
                      labelText="Select level"
                      defaultValue={selectDropDownValue?.level}
                      displayEmpty
                      variant="outlined"
                      itemArr={levelData}
                      parentcall={handleSelectedValue}
                    />
                  </div>
                </Grid>
                <Grid item xs={2} lg={5} md={6}>
                  <div
                    className={classes.fieldSelection}
                    style={{ justifyContent: "center", marginRight: "85px" }}
                  >
                    <Typography
                      variant="h2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "8px",
                      }}
                    >
                      Rate card type
                    </Typography>
                    <CustomSelect
                      disabled={stepperValue === 0}
                      id="rate_card_type"
                      labelText="Select"
                      name="rate_card_type"
                      targetId={"rate_card_type"}
                      displayEmpty
                      variant="outlined"
                      itemArr={rateCardType}
                      defaultValue={selectDropDownValue?.rate_card_type}
                      parentcall={handleSelectedValue}
                    />
                  </div>
                </Grid>
                <Grid item xs={2} md={3} lg={2} style={{ textAlign: "right" }}>
                  <Button
                    disabled={stepperValue !== 2}
                    style={{ textTransform: "capitalize" }}
                    disableRipple
                    variant="contained"
                    onClick={() => {
                      setViewCardPopover(true);
                    }}
                    color="secondary"
                  >
                    Select rate card
                  </Button>
                  {submitClickFlag &&
                    !Object.keys(priceSummaryData)?.length && (
                      <span style={{ color: "red", display: "block" }}>
                        Please select a rate card value to proceed further
                      </span>
                    )}
                </Grid>
              </Grid>
            </Box>

            <Grid container alignItems="center" spacing={5}>
              <Grid item md={2} lg={1}>
                <Typography variant="subtitle1">Add-ons</Typography>
              </Grid>
              <Grid item md={10} lg={6}>
                <div>
                  <CustomSelectMulti
                    id="add_ons"
                    name="add_ons"
                    itemArr={addonOption}
                    parentcall={onChangeMultiItem}
                    placeholder="Select Title"
                    value={addonData?.map((item) => ({
                      ...item,
                      value: item.label,
                    }))}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={5} className={classes.summery}>
              <Grid item xs={8}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Price summary
                </Typography>
                <TableContainer component={Paper} className={classes.tableRoot}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Label</TableCell>
                        <TableCell>Rate card type</TableCell>
                        {selectDropDownValue?.rate_card_type !==
                        rateCardType[0] ? (
                          <TableCell>Rate</TableCell>
                        ) : (
                          <TableCell></TableCell>
                        )}
                        <TableCell>
                          {(rateCardType[1] ===
                            selectDropDownValue.rate_card_type &&
                            "No of hrs in a session") ||
                            (rateCardType[2] ===
                              selectDropDownValue.rate_card_type &&
                              "No of hrs")}
                        </TableCell>
                        <TableCell colSpan={2}>Price</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{priceSummaryData?.label || "-"}</TableCell>
                        <TableCell>
                          {priceSummaryData?.rate_card_type || "-"}
                        </TableCell>

                        {selectDropDownValue?.rate_card_type ===
                        rateCardType[2] ? (
                          <TableCell>
                            {priceSummaryData?.hourly_rate || "-"}
                          </TableCell>
                        ) : selectDropDownValue?.rate_card_type ===
                          rateCardType[1] ? (
                          <TableCell>
                            {priceSummaryData?.session_rate || "-"}
                          </TableCell>
                        ) : (
                          <TableCell />
                        )}

                        <TableCell>
                          {rateCardType[0] ===
                          selectDropDownValue.rate_card_type
                            ? ""
                            : "" ||
                              rateCardType[1] ===
                                selectDropDownValue.rate_card_type
                            ? priceSummaryData?.num_of_hours
                            : "-" ||
                              rateCardType[2] ===
                                selectDropDownValue.rate_card_type
                            ? priceSummaryData?.num_of_hours
                            : "-"}
                        </TableCell>
                        <TableCell>
                          {priceSummaryData?.currency}{" "}
                          {priceSummaryData?.price || "-"}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color="inherit"
                            onClick={() =>
                              handlePriceSummaryModal(
                                true,
                                "totalCoachingProgramPrice",
                                priceSummaryData?.rate_card_type
                              )
                            }
                          >
                            {priceSummaryData?.price ? <EditIcon /> : ""}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <strong>Coaching program price</strong>
                        </TableCell>
                        <TableCell>
                          <strong>
                            {priceSummaryData?.currency}{" "}
                            {priceSummaryData?.price || "-"}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <strong>Total Coaching program price</strong>
                        </TableCell>
                        <TableCell colSpan={2}>
                          <strong>
                            {priceSummaryData?.currency}{" "}
                            {priceSummaryData?.price || "-"}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {addonData?.length ? (
                        addonData?.map((data, index) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell colSpan={1}>
                                  {data ? data?.label : "-"}
                                </TableCell>
                                <TableCell />
                                <TableCell />
                                <TableCell />
                                <TableCell>
                                  {priceSummaryData?.currency}{" "}
                                  {data?.price || 0}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    color="inherit"
                                    onClick={() =>
                                      handlePriceSummaryModal(
                                        true,
                                        "totalProgramPrice",
                                        index
                                      )
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })
                      ) : (
                        <>
                          <TableRow>
                            <TableCell colSpan={1}>{"-"}</TableCell>
                            <TableCell />
                            <TableCell />
                            <TableCell>-</TableCell>
                            <TableCell>
                              <Icon>-</Icon>
                            </TableCell>
                          </TableRow>
                        </>
                      )}
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <strong>Specified elements price</strong>
                        </TableCell>
                        <TableCell>
                          <strong>
                            {priceSummaryData?.currency} {elementPrice || 0}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell />
                        <TableCell>
                          <strong>Total program price</strong>
                        </TableCell>
                        <TableCell colSpan={2}>
                          <strong>
                            {priceSummaryData?.currency}{" "}
                            {priceSummaryData?.price + elementPrice || 0 || "-"}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </TableContainer>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Margin percent %
                </Typography>
                <TableContainer
                  component={Paper}
                  className={classes.marginTableRoot}
                >
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>For Acuity</TableCell>
                        <TableCell>For Coach</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow height={80}>
                        <TableCell>
                          <CustomInput
                            id="for_acuity"
                            variant="outlined"
                            name="for_acuity"
                            targetId={"for_acuity"}
                            value={inputValue?.for_acuity}
                            parentcall={handleInputChange}
                            type={"number"}
                            helperText={
                              submitClickFlag && inputValue?.for_acuity == ""
                                ? "Enter value."
                                : ""
                            }
                            error={
                              submitClickFlag && inputValue?.for_acuity == ""
                                ? true
                                : false
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <CustomInput
                            id="for_coach"
                            variant="outlined"
                            name="for_coach"
                            targetId={"for_coach"}
                            value={inputValue?.for_coach}
                            parentcall={handleInputChange}
                            type={"number"}
                            helperText={
                              submitClickFlag && inputValue?.for_coach == ""
                                ? "Enter value."
                                : ""
                            }
                            error={
                              submitClickFlag && inputValue?.for_coach == ""
                                ? true
                                : false
                            }
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow height={54}>
                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                      <TableRow height={56}>
                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                      <TableRow></TableRow>
                      {addonData?.map((item, index) => {
                        return (
                          <>
                            <TableRow height={80}>
                              <TableCell>
                                <CustomInput
                                  id="acuity_margin_percent"
                                  variant="outlined"
                                  name="for_acuity_add_ons"
                                  targetId={"for_acuity_add_ons"}
                                  value={item?.acuity_margin_percent}
                                  parentcall={(value, name) =>
                                    handlePriceSummaryInputChange(
                                      value,
                                      name,
                                      index,
                                      "addOn"
                                    )
                                  }
                                  type={"number"}
                                  helperText={
                                    submitClickFlag
                                      ? item?.acuity_margin_percent
                                        ? ""
                                        : "Enter value."
                                      : null
                                  }
                                  error={
                                    submitClickFlag
                                      ? item?.acuity_margin_percent
                                        ? false
                                        : true
                                      : null
                                  }
                                />
                              </TableCell>
                              <TableCell>
                                <CustomInput
                                  id="coach_margin_percent"
                                  variant="outlined"
                                  name="for_coach_add_ons"
                                  targetId={"for_coach_add_ons"}
                                  value={item?.coach_margin_percent}
                                  parentcall={(value, name) =>
                                    handlePriceSummaryInputChange(
                                      value,
                                      name,
                                      index,
                                      "addOn"
                                    )
                                  }
                                  type={"number"}
                                  helperText={
                                    submitClickFlag
                                      ? item?.coach_margin_percent
                                        ? ""
                                        : "Enter value."
                                      : null
                                  }
                                  error={
                                    submitClickFlag
                                      ? item?.coach_margin_percent
                                        ? false
                                        : true
                                      : null
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
            <Grid style={{ marginLeft: "40px" }}>
              <Grid className={classes.clientBasics}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Client invoicing basics
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <Grid
                      container
                      style={{
                        paddingLeft: "10px",
                        height: "40px",
                        backgroundColor: "#ef700080",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        PO
                      </Typography>
                    </Grid>

                    {clientInvoicingBasics.PO.map((data, index) => {
                      return (
                        <Grid item xs={12} spacing={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={data?.name}
                                color="primary"
                                checked={Boolean(checkBoxValue[data?.name])}
                              />
                            }
                            onChange={handleCheckboxValue}
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      container
                      style={{
                        paddingLeft: "10px",
                        height: "40px",
                        backgroundColor: "#ef700080",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        Billing
                      </Typography>
                    </Grid>
                    {clientInvoicingBasics.BILLING.map((data, index) => {
                      return (
                        <Grid item xs={12} spacing={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={data?.name}
                                color="primary"
                                checked={Boolean(checkBoxValue[data?.name])}
                              />
                            }
                            onChange={handleCheckboxValue}
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      container
                      style={{
                        paddingLeft: "10px",
                        height: "40px",
                        backgroundColor: "#ef700080",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        Supplier
                      </Typography>
                    </Grid>
                    {clientInvoicingBasics.SUPPLIERS.map((data, index) => {
                      return (
                        <Grid item xs={12} spacing={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={data?.name}
                                color="primary"
                                checked={Boolean(checkBoxValue[data?.name])}
                              />
                            }
                            onChange={handleCheckboxValue}
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Grid item xs={3}>
                    <Grid
                      container
                      style={{
                        paddingLeft: "10px",
                        height: "40px",
                        backgroundColor: "#ef700080",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bold",
                          textAlign: "left",
                          padding: "5px",
                        }}
                      >
                        Assignments
                      </Typography>
                    </Grid>
                    {clientInvoicingBasics.ASSIGNMENTS.map((data, index) => {
                      return (
                        <Grid item xs={12} spacing={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={data?.name}
                                color="primary"
                                checked={Boolean(checkBoxValue[data?.name])}
                              />
                            }
                            onChange={handleCheckboxValue}
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: "bold", flex: 3 }}
                    >
                      Payment terms
                    </Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      inputProps={{ maxLength: 20 }}
                      name={`payment_terms`}
                      style={{ flex: 6, marginRight: 8 }}
                      onChange={handleChangeTextArea}
                      value={textAreaValue?.payment_terms}
                      placeholder="Type here"
                    />
                    <Typography variant="body1" style={{ flex: 3, marginLeft: 8 }}>
                      days
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Divider style={{ margin: "30px 0", width: "100%" }} />
              <Grid container className={classes.invoice}>
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    Client invoicing schedule
                  </Typography>
                  <Grid container>
                    {clientInvoicingScheduleArray?.map((data, index) => {
                      return (
                        <Grid item xs={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                id={data.id}
                                name={data.name}
                                value={data.value}
                                color="primary"
                                checked={data.name === clientInvoicingCheck}
                              />
                            }
                            onChange={(e) => clientInvoicingHandle(data?.id, e)}
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>

                  <Grid item xs={3}>
                    {clientInvoicingScheduleArray[0].name ===
                    clientInvoicingCheck ? (
                      <CustomSelect
                        id="num_of_tranche"
                        labelText="Select"
                        name="num_of_tranche"
                        targetId={"num_of_tranche"}
                        displayEmpty
                        variant="outlined"
                        itemArr={["1", "2", "3", "4", "5"]}
                        defaultValue={selectDropDownValue?.num_of_tranche}
                        parentcall={handleSelectedValue}
                        required={clientInvoicingSelectedId === 1}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    Add-ons invoicing schedule
                  </Typography>
                  <Grid container>
                    {addOnsInvoicingScheduleArray?.map((data) => {
                      return (
                        <Grid item xs={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                id={data.id}
                                name={data.name}
                                value={data.value}
                                color="primary"
                                checked={data?.name === addOnsInvoicingCheck}
                              />
                            }
                            label={
                              <Typography variant="h2">{data.value}</Typography>
                            }
                            onChange={(e) => addOnsInvoicingHandle(data?.id, e)}
                            className={classes.paper}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Grid item xs={3}>
                    {addOnsInvoicingScheduleArray[0].name ===
                    addOnsInvoicingCheck ? (
                      <CustomSelect
                        id="add_on_num_of_tranche"
                        labelText="Select"
                        name="num_of_tranche"
                        targetId={"num_of_tranche"}
                        displayEmpty
                        variant="outlined"
                        itemArr={["1", "2", "3", "4", "5"]}
                        defaultValue={
                          selectDropDownValue?.add_on_num_of_tranche
                        }
                        parentcall={handleSelectedValue}
                        required={addOnsInvoicingSelectedId === 1}
                      />
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              <Divider style={{ margin: "30px 0", width: "100%" }} />

              <Grid style={{}} container spacing={5}>
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    Client billing schedule
                  </Typography>

                  {clientInvoicingScheduleArray[0].name ===
                    clientInvoicingCheck &&
                  clientBillingPercentTotal &&
                  clientBillingPercentTotal != 100 ? (
                    <Alert severity="warning">
                      <Typography variant="h2">
                        Please enter percentage value to achieve 100%
                      </Typography>
                    </Alert>
                  ) : (
                    <></>
                  )}
                  {!clientInvoicingCheck && (
                    <Alert severity="warning">
                      <Typography variant="h2">
                        {" "}
                        Please enter any client invoicing schedule.
                      </Typography>
                    </Alert>
                  )}
                  {clientInvoicingScheduleArray[1].name ===
                  clientInvoicingCheck ? (
                    <>
                      <Grid
                        container
                        spacing={5}
                        style={{
                          marginTop: "16px",
                          marginLeft: "3px",
                        }}
                      >
                        <Grid>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Typography variant="h2">
                              Invoice after completion of &nbsp;
                            </Typography>
                            <CustomInput
                              inputProps={{ maxLength: 3 }}
                              maxLength={2}
                              name="session"
                              targetId={"client_num_of_session"}
                              id={"client_num_of_session"}
                              style={{ width: "50%" }}
                              type={"number"}
                              parentcall={handleInputChange}
                              value={inputValue?.client_num_of_session || ""}
                            />

                            <Typography
                              variant="h2"
                              style={{ marginLeft: "-6.5rem" }}
                            >
                              &nbsp;of sessions
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) : clientInvoicingScheduleArray[2].name ===
                    clientInvoicingCheck ? (
                    <>
                      <Grid
                        container
                        spacing={5}
                        style={{ marginTop: "16px", marginLeft: "3px" }}
                      >
                        <Grid>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Typography variant="h2">
                              Invoice after completion of &nbsp;
                            </Typography>
                            <CustomInput
                              inputProps={{ maxLength: 3 }}
                              maxLength={2}
                              name="monthly"
                              targetId={"client_num_of_month"}
                              id={"client_num_of_month"}
                              style={{ width: "50%" }}
                              type={"number"}
                              parentcall={handleInputChange}
                              value={inputValue?.client_num_of_month || ""}
                            />
                            <Typography
                              variant="h2"
                              style={{ marginLeft: "-6.5rem" }}
                            >
                              &nbsp;of monthly
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) : clientInvoicingScheduleArray[0].name ===
                    clientInvoicingCheck ? (
                    clientBillingScheduleArray &&
                    clientBillingScheduleArray.map((data, index) => {
                      return (
                        <>
                          <Grid
                            container
                            spacing={3}
                            style={{
                              alignItems: "center",
                            }}
                          >
                            <Grid item xs={2}>
                              {/*<TextField placeholder="Age" />*/}
                              <CustomInput
                                inputProps={{ maxLength: 3 }}
                                placeholder="percentage"
                                name="percentage"
                                targetId={"percentage"}
                                id={"percentage"}
                                value={data?.percentage?.replace("%", "")}
                                parentcall={(value, id) => {
                                  handleClientBillingSchedules(
                                    value,
                                    id,
                                    index
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={5}>
                              <CustomSelect
                                id="pgm_price_type"
                                labelText="Program price type"
                                displayEmpty
                                variant="outlined"
                                itemArr={programPriceType}
                                name={"pgm_price_type"}
                                targetId={"pgm_price_type"}
                                defaultValue={data?.pgm_price_type}
                                parentcall={(event) => {
                                  handleClientBillingSchedules(
                                    event,
                                    "",
                                    index
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <CustomSelect
                                id="installment_type"
                                labelText="Installment type"
                                displayEmpty
                                variant="outlined"
                                itemArr={installmentType}
                                name={"installment_type"}
                                targetId={"installment_type"}
                                defaultValue={data?.installment_type}
                                parentcall={(event) => {
                                  handleClientBillingSchedules(
                                    event,
                                    "",
                                    index
                                  );
                                }}
                              />
                            </Grid>
                            <Grid item xs={1}>
                              {clientBillingScheduleArray.length - 1 !==
                                index && (
                                <RemoveCircleOutlinedIcon
                                  type={"submit"}
                                  fontSize="large"
                                  onClick={() =>
                                    removeClientBillingSchedules(index)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                />
                              )}
                              {clientBillingScheduleArray.length - 1 ===
                                index && (
                                <AddCircleIcon
                                  type="submit"
                                  onClick={addClientBillingSchedules}
                                  fontSize="large"
                                  color="primary"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </Grid>
                            {data.pgm_price_type === programPriceType[1] && (
                              <Grid
                                container
                                spacing={5}
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={5}>
                                  <CustomInput
                                    inputProps={{ maxLength: 3 }}
                                    placeholder="Enter hours"
                                    name="hours"
                                    targetId={"hours"}
                                    id={"completion_time"}
                                    value={data?.completion_time}
                                    parentcall={(value, id) => {
                                      handleClientBillingSchedules(
                                        value,
                                        id,
                                        index
                                      );
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            )}
                            {data.pgm_price_type === programPriceType[2] && (
                              <Grid
                                container
                                spacing={5}
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={5}>
                                  <CustomInput
                                    inputProps={{ maxLength: 3 }}
                                    placeholder="Enter sessions"
                                    name="session"
                                    targetId={"session"}
                                    id={"completion_time"}
                                    value={data?.completion_time}
                                    parentcall={(value, id) => {
                                      handleClientBillingSchedules(
                                        value,
                                        id,
                                        index
                                      );
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </>
                      );
                    })
                  ) : null}
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    Add-ons billing schedule
                  </Typography>
                  {addonData?.length &&
                  addOnsInvoicingScheduleArray[0].name ===
                    addOnsInvoicingCheck &&
                  addOnsPercentTotal != 100 ? (
                    <Alert severity="warning">
                      <Typography variant="h2">
                        Please enter percentage value to achieve 100%
                      </Typography>
                    </Alert>
                  ) : (
                    <></>
                  )}
                  {!addOnsInvoicingCheck && (
                    <Alert severity="warning">
                      <Typography variant="h2">
                        Please enter any Add-ons invoicing schedule.
                      </Typography>
                    </Alert>
                  )}

                  {addOnsInvoicingScheduleArray[1].name ===
                  addOnsInvoicingCheck ? (
                    <>
                      <Grid
                        container
                        spacing={5}
                        style={{ marginTop: "16px", marginLeft: "3px" }}
                      >
                        <Grid>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Typography variant="h2">
                              Invoice after completion of &nbsp;
                            </Typography>
                            <CustomInput
                              inputProps={{ maxLength: 3 }}
                              maxLength={2}
                              name="session"
                              targetId={"addons_num_of_session"}
                              id={"addons_num_of_session"}
                              style={{ width: "50%" }}
                              type={"number"}
                              parentcall={handleInputChange}
                              value={inputValue?.addons_num_of_session || ""}
                            />
                            <Typography
                              variant="h2"
                              style={{ marginLeft: "-6.5rem" }}
                            >
                              &nbsp;of sessions
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) : addOnsInvoicingScheduleArray[2].name ===
                    addOnsInvoicingCheck ? (
                    <>
                      <Grid
                        container
                        spacing={5}
                        style={{ marginTop: "16px", marginLeft: "3px" }}
                      >
                        <Grid>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Typography variant="h2">
                              Invoice after completion of &nbsp;
                            </Typography>
                            <CustomInput
                              inputProps={{ maxLength: 3 }}
                              maxLength={2}
                              name="monthly"
                              targetId={"addons_num_of_month"}
                              id={"addons_num_of_month"}
                              style={{ width: "50%" }}
                              type={"number"}
                              parentcall={handleInputChange}
                              value={inputValue?.addons_num_of_month || ""}
                            />
                            <Typography
                              variant="h2"
                              style={{ marginLeft: "-6.5rem" }}
                            >
                              &nbsp;of monthly
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </>
                  ) : addOnsInvoicingScheduleArray[0].name ===
                    addOnsInvoicingCheck ? (
                    addOnBillingScheduleArray &&
                    addOnBillingScheduleArray.map((data, index) => {
                      return (
                        <>
                          <Grid
                            container
                            spacing={3}
                            style={{
                              alignItems: "center",
                            }}
                          >
                            <Grid item xs={2}>
                              {/*<TextField placeholder="Age" />*/}
                              <CustomInput
                                placeholder="percentage"
                                name="percentage"
                                targetId={"percentage"}
                                id={"percentage"}
                                value={data?.percentage?.replace("%", "")}
                                parentcall={(value, id) => {
                                  handleAddOnBillingSchedules(value, id, index);
                                }}
                              />
                            </Grid>
                            <Grid item xs={5}>
                              <CustomSelect
                                id="pgm_price_type"
                                labelText="Program price type"
                                displayEmpty
                                variant="outlined"
                                itemArr={addOnsPriceType}
                                name={"pgm_price_type"}
                                targetId={"pgm_price_type"}
                                defaultValue={data?.pgm_price_type}
                                parentcall={(event) => {
                                  handleAddOnBillingSchedules(event, "", index);
                                }}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <CustomSelect
                                id="installment_type"
                                labelText="Installment type"
                                displayEmpty
                                variant="outlined"
                                itemArr={installmentType}
                                name={"installment_type"}
                                targetId={"installment_type"}
                                defaultValue={data?.installment_type}
                                parentcall={(event) => {
                                  handleAddOnBillingSchedules(event, "", index);
                                }}
                              />
                            </Grid>
                            <Grid item xs={1}>
                              {addOnBillingScheduleArray.length - 1 !==
                                index && (
                                <RemoveCircleOutlinedIcon
                                  type={"submit"}
                                  fontSize="large"
                                  onClick={() =>
                                    removeAddOnBillingSchedules(index)
                                  }
                                  style={{
                                    cursor: "pointer",
                                    color: "red",
                                  }}
                                />
                              )}
                              {addOnBillingScheduleArray.length - 1 ===
                                index && (
                                <AddCircleIcon
                                  type="submit"
                                  onClick={addAddOnBillingSchedules}
                                  fontSize="large"
                                  color="primary"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </Grid>
                            {data.pgm_price_type == addOnsPriceType[1] && (
                              <Grid
                                container
                                spacing={5}
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={5}>
                                  <CustomInput
                                    inputProps={{ maxLength: 3 }}
                                    placeholder="Enter hours"
                                    name="hours1"
                                    targetId={"completion_time"}
                                    id={"completion_time"}
                                    value={data?.completion_time}
                                    parentcall={(value, id) => {
                                      handleAddOnBillingSchedules(
                                        value,
                                        id,
                                        index
                                      );
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            )}
                            {data.pgm_price_type == addOnsPriceType[2] && (
                              <Grid
                                container
                                spacing={5}
                                style={{
                                  alignItems: "center",
                                }}
                              >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={5}>
                                  <CustomInput
                                    inputProps={{ maxLength: 3 }}
                                    placeholder="Enter sessions"
                                    name="session1"
                                    targetId={"completion_time"}
                                    id={"completion_time"}
                                    value={data?.completion_time}
                                    parentcall={(value, id) => {
                                      handleAddOnBillingSchedules(
                                        value,
                                        id,
                                        index
                                      );
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </>
                      );
                    })
                  ) : null}
                </Grid>
              </Grid>

              <Divider style={{ margin: "30px 0", width: "100%" }} />

              <Grid container className={classes.invoiceOption}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Client invoicing options
                </Typography>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="client_invoice"
                        color="primary"
                        checked={Boolean(checkBoxValue?.client_invoice)}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label={<Typography variant="h2">Client invoice</Typography>}
                    className={classes.paper}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="raise_proforma"
                        color="primary"
                        checked={Boolean(checkBoxValue?.raise_proforma)}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label={<Typography variant="h2">Raise Proforma</Typography>}
                    className={classes.paper}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="drawdone_from_single_payment"
                        color="primary"
                        checked={Boolean(
                          checkBoxValue?.drawdone_from_single_payment
                        )}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label={
                      <Typography variant="h2">
                        Drawdown from single payment
                      </Typography>
                    }
                    className={classes.paper}
                  />
                </Grid>
              </Grid>

              <Divider style={{ margin: "30px 0", width: "100%" }} />

              <Grid container className={classes.invoiceDetails}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Client invoicing details
                </Typography>
                <h2></h2>
                <Grid container>
                  <Grid xs={1}>
                    <Typography variant="h2" style={{ fontWeight: "bold" }}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid xs={8} style={{ marginBottom: "2rem" }}>
                    <CustomInput
                      placeholder="Name"
                      name="name"
                      style={{ width: "70%" }}
                      targetId={"name"}
                      id={"name"}
                      value={inputValue?.name}
                      parentcall={handleInputChange}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid xs={1}>
                    <Typography variant="h2" style={{ fontWeight: "bold" }}>
                      Invoice address
                    </Typography>
                  </Grid>
                  <Grid xs={8} style={{ marginBottom: "2rem" }}>
                    <CustomInput
                      style={{ width: "70%" }}
                      name="invoice_address"
                      placeholder="Invoice Address"
                      targetId={"invoice_address"}
                      id={"invoice_address"}
                      parentcall={handleInputChange}
                      value={inputValue?.invoice_address}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    xs={1}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography variant="h2" style={{ fontWeight: "bold" }}>
                      Email
                    </Typography>
                  </Grid>
                  <Grid xs={10} style={{ marginBottom: "2rem" }}>
                    <Autocomplete
                      id="email"
                      name={"email"}
                      multiple
                      freeSolo
                      disableCloseOnSelect
                      value={emailData || ""}
                      options={[]}
                      className={classes.chipComponent}
                      getOptionLabel={(option) => option}
                      getOptionSelected={(option, value) => value === option}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            variant="outlined"
                            label={option}
                            {...getTagProps({ index })}
                          />
                        ))
                      }
                      style={{ width: "70%" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Email"
                          variant="standard"
                          fullWidth
                        />
                      )}
                      onChange={(_, selectedOptions) =>
                        setEmailData(selectedOptions)
                      }
                    />
                    <Typography
                      variant="caption"
                      display="block"
                      style={{ marginTop: 1, color: "gray" }}
                    >
                      Hit enter after typing email.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid xs={1}>
                    <Typography variant="h2" style={{ fontWeight: "bold" }}>
                      Invoice narrative
                    </Typography>
                  </Grid>
                  <Grid xs={8}>
                    <CustomInput
                      style={{ width: "70%" }}
                      name={"invoice_narrative"}
                      placeholder="Invoice narrative"
                      targetId={"invoice_narrative"}
                      id={"invoice_narrative"}
                      parentcall={handleInputChange}
                      value={inputValue?.invoice_narrative}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Divider style={{ margin: "30px 0", width: "100%" }} />

              <Grid container xs={10} className={classes.expensePolicy}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bold" }}
                  >
                    Client expense policy
                  </Typography>
                </Grid>
                <Grid xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="expenses_reclaimable_from_client"
                        color="primary"
                        checked={Boolean(
                          checkBoxValue?.expenses_reclaimable_from_client
                        )}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label={
                      <Typography variant="h2">
                        Expenses reclaimable from client
                      </Typography>
                    }
                    className={classes.paper}
                  />
                </Grid>
                <Grid xs={3} />
                <Grid xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="coach_can_claim_expenses_from_acuity"
                        color="primary"
                        checked={Boolean(
                          checkBoxValue?.coach_can_claim_expenses_from_acuity
                        )}
                      />
                    }
                    onChange={handleCheckboxValue}
                    label={
                      <Typography variant="h2">
                        Coach can claim expenses from Acuity
                      </Typography>
                    }
                    className={classes.paper}
                  />
                </Grid>
                <Divider style={{ margin: "30px 0", width: "100%" }} />
              </Grid>

              {expencePolicyArray?.map((data, index) => {
                return (
                  <Grid
                    container
                    xs={10}
                    style={{ marginBottom: "50px" }}
                    className={classes.expensePolicy}
                  >
                    <>
                      <Grid xs={3}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name={`expense_available`}
                              color="primary"
                              checked={Boolean(data?.expense_available)}
                            />
                          }
                          label={
                            <Typography variant="h2">
                              {data?.policy_type.charAt(0).toUpperCase() +
                                data?.policy_type.slice(1).replace("_", " ")}
                            </Typography>
                          }
                          onChange={(e) => {
                            handleExpencePolicyDetail(
                              Boolean(e.target.checked),
                              e.target.name,
                              index
                            );
                          }}
                          className={classes.paper}
                        />
                        <TextField
                          disabled={
                            Boolean(!data?.expense_available) ? true : false
                          }
                          id="expense_description"
                          name="expense_description"
                          placeholder="Description"
                          multiline
                          rows={4}
                          value={data?.expense_description}
                          variant="outlined"
                          onChange={(e) => {
                            handleExpencePolicyDetail(
                              e.target.value || "",
                              e.target.name,
                              index
                            );
                          }}
                        />
                      </Grid>
                      <Grid xs={3} />
                      <Grid item xs={6}>
                        {index == 0 ? (
                          <Typography variant="h2">
                            Frequency/milestones
                          </Typography>
                        ) : null}
                        <CustomSelect
                          disabled={
                            Boolean(!data?.expense_available) ? true : false
                          }
                          id={`expense_frequency`}
                          labelText="Select"
                          displayEmpty
                          variant="outlined"
                          itemArr={frequencyMilestoneArray}
                          parentcall={(event) => {
                            handleExpencePolicyDetail(
                              event?.value,
                              event?.id,
                              index
                            );
                          }}
                          name={`expense_frequency`}
                          targetId={`expense_frequency`}
                          style={{ marginBottom: "1rem" }}
                          defaultValue={data?.expense_frequency}
                        />
                        {data?.expense_frequency == "Other" ? (
                          <TextField
                            disabled={
                              Boolean(!data?.expense_available) ? true : false
                            }
                            style={{ marginBottom: "1rem", width: "100%" }}
                            id="other_frequency_value"
                            name={"other_frequency_value"}
                            placeholder="Other"
                            multiline
                            rows={4}
                            value={data?.other_frequency_value}
                            variant="outlined"
                            onChange={(e) => {
                              handleExpencePolicyDetail(
                                e.target.value,
                                e.target.name,
                                index
                              );
                            }}
                          />
                        ) : null}
                      </Grid>
                    </>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          {action && (
            <InternalExternalRate
              action={action}
              setRefresh={setRefresh}
              refresh={refresh}
              ExternalCoaching={ExternalCoaching}
              InternalCoaching={InternalCoaching}
              organisationId={organisationId}
              externalSelection={currentRateCardSelection}
              internalSelection={currentRateCardSelection}
              regionName={countryData}
              regionId={currentRateCardSelection?.available_region_id}
              handleClose={handleClose}
              handleClose1={handleClose1}
            />
          )}

          {priceSummaryModal && (
            <PriceSummaryModal
              priceSummaryFlag={priceSummaryFlag}
              setPriceSummaryModal={setPriceSummaryModal}
              currentSelection={currentSelection}
              isOpen={priceSummaryModal}
              onModalClose={() => {
                handlePriceSummaryModal(false, "");
              }}
              onChangeInputValue={handlePriceSummaryInputChange}
              onChangeSelectedValue={handleSelectedValue}
              inputValue={inputValue}
              selectedValue={selectDropDownValue}
              setInputValue={setPriceSummaryInputValue}
              rateCardInfo={rateCardInfo}
              setElementPrice={setElementPrice}
              handleSubmit={handleModalSubmit}
              addonData={addonData}
              priceSummaryData={priceSummaryData}
              coachingPrice={coachingPrice}
            />
          )}
        </Container>

        <div className={classes.bottomBar}>
          <Button
            onClick={() => props.handleClose()}
            className={classes.buttonCss}
            style={{ marginRight: "10px" }}
            disabled={nextButtonLoading}
            type="submit"
            variant="contained"
          >
            Close
          </Button>
          <Button
            className={classes.buttonCss}
            type="submit"
            disabled={nextButtonLoading}
            variant="contained"
            color="secondary"
          >
            Next
          </Button>
        </div>
      </form>
      <Dialog
        fullScreen
        open={viewCardPopover}
        onClose={() => setViewCardPopover(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ top: "5%" }}
        TransitionComponent={Transition}
      >
        <DialogContent>
          <div className={classes.popOverRoot}>
            <Grid
              container
              alignItems="center"
              spacing={5}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={3}>
                <Grid container alignItems={"center"}>
                  <p>Rate Card Information </p> &nbsp;&nbsp;
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={() => {
                      history.push("/admin/organisation/list");
                    }}
                  >
                    Edit
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={9}>
                <FormControl variant="outlined" className={classes.formControl}>
                  <SelectSpecific
                    componentObject={{
                      type: "",
                      value: countryData,
                      placeholder: "Select Country",
                      selectOptions: countryList,
                      handleChange: handleCountryChange,
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container alignItems={"center"} spacing={5}>
              <Grid item xs={12}>
                <MaterialTable
                  style={{ padding: "0 8px" }}
                  title={
                    <Typography
                      style={{ fontSize: "20px", marginLeft: "0" }}
                      color="secondary"
                    >
                      Note: Please make sure the selected country have a rate
                      card and catches the service and service type of this
                      program.
                    </Typography>
                  }
                  options={{
                    search: false,
                    searchable: false,
                    actionsColumnIndex: -1,
                    searchFieldAlignment: "left",
                    pageSize: pageSize,
                    total: totalCount,
                    actionsCellStyle: {
                      width: "15%",
                    },
                  }}
                  columns={[
                    { title: "Level", field: "level", emptyValue: "-" },
                    { title: "Label", field: "label", emptyValue: "-" },
                    {
                      title: "Program Price",
                      field: "programme_price",
                      emptyValue: "-",
                    },
                    {
                      title: "HRs for Program",
                      field: "programme_hours",
                      emptyValue: "-",
                    },
                    {
                      title: "Session Rate",
                      field: "session_rate",
                      emptyValue: "-",
                    },
                    {
                      title: "No of hrs in a session",
                      field: "num_of_hours_in_a_session",
                      emptyValue: "-",
                    },
                    {
                      title: "Hourly Rate",
                      field: "hourly_rate",
                      emptyValue: "-",
                    },
                  ]}
                  data={rateCardInfo}
                  totalCount={totalCount}
                  page={page}
                  onRowClick={(e, rowData) => {
                    setCurrentRateCardSelection(rowData);
                  }}
                  onChangePage={(page) => {
                    setPage(page);
                  }}
                  onChangeRowsPerPage={(pageSize) => {
                    setPageSize(pageSize);
                  }}
                  onSearchChange={(search) => {}}
                  actions={[
                    {
                      icon: () => <EditIcon fontSize="small" />,
                      tooltip: <TooltipWrapper text="Edit" />,
                      onClick: (event, rowData) => {
                        setCurrentRateCardSelection(rowData);
                        setAction("edit");
                      },
                    },
                    {
                      icon: () => (
                        <Button
                          disableElevation
                          disableRipple
                          disableTouchRipple
                          variant="contained"
                          color={"primary"}
                          size="small"
                        >
                          {" "}
                          Select rate card{" "}
                        </Button>
                      ),
                      onClick: (event, rowData) => {
                        setCurrentRateCardSelection(rowData);
                        console.log("rowData", rowData);
                        setSelectDropDownValue((prev) => ({
                          ...prev,
                          level: rowData.level,
                          rate_card_id: rowData.id,
                        }));
                        setStepperValue(2);
                        setViewCardPopover(false);
                      },
                    },
                  ]}
                />
              </Grid>
              {console.log("selectDropDownValue", selectDropDownValue)}
            </Grid>
            <Button
              style={{ float: "right", marginTop: "15px" }}
              onClick={() => setViewCardPopover(false)}
              variant={"contained"}
              color="secondary"
            >
              Close
            </Button>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};
export default CoachingCommercialClient;
